import { Suspense, lazy } from "react"
import { createBrowserRouter, redirect, RouteObject } from "react-router-dom"
import ErrorPage from "./error-page"
import PageNotFound from "./page-not-found"
import publicPages from "./public-pages"
import { Loading } from "@components/loading"

// pages
import { authPages } from "./auth-pages"
import { FinApi } from "../../packages/features/finapi"

// routes
import ProtectedRoutes from "./routes/protected-routes"
import Root from "./routes/root"
import AuthRoutes from "./routes/auth-routes"
const FinApiRoutes = lazy(() => import("./routes/finapi-routes"))

export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Suspense fallback={<Loading />}>
        <Root />
      </Suspense>
    ),
    errorElement: <ErrorPage solidBg />,
    children: [
      ...publicPages,
      {
        path: "",
        element: <ProtectedRoutes />,
        errorElement: <ErrorPage solidBg />,
        children: [
          {
            path: "",
            element: <AuthRoutes />,
            children: authPages as RouteObject[],
          },
        ],
      },
      {
        path: "/",
        element: <ProtectedRoutes />,
        errorElement: <ErrorPage solidBg />,
        children: [
          {
            path: "/finapi",
            element: <FinApiRoutes />,
            children: FinApi as RouteObject[],
          },
        ],
      },
      {
        path: "/404",
        element: <PageNotFound />,
      },
      {
        path: "*",
        element: <PageNotFound />,
      },
    ],
  },
  {
    path: "/log-out",
    async action() {
      // We signout in a "resource route" that we can hit from a fetcher.Form
      return redirect("/")
    },
  },
])
